import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { PcsModalDirective } from '@app/core/components/modal/modal';
import { CloseModalWithReason } from '@app/core/pcs-modal';
import { PcsTranslateService } from '@app/core/translate/translate.service';
import { requiredValidator } from '@app/shared/validators';
import { Store } from '@ngrx/store';
import { hasNoValue } from '@util';
import { createActionWithCorrelationId, getCorrelationId, hasCorrelationId } from '@util/correlation-id-helper';
import * as R from 'ramda';

@Component({
  selector: 'pcs-confirmation-modal-with-reason',
  templateUrl: './confirmation-modal-with-reason.component.html',
  styleUrls: ['../base-confirmation-modal-component.scss']
})
export class ConfirmationModalWithReasonComponent extends PcsModalDirective implements OnInit {
  form: UntypedFormGroup;

  constructor(protected store: Store<any>,
    protected translateService: PcsTranslateService,
    private formBuilder: UntypedFormBuilder) {
    super(store, translateService);
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      reason: new UntypedFormControl('', requiredValidator())
    });
  }

  onConfirm() {
    super.onConfirm();
    this.store.dispatch(this.createCloseAction());
  }

  private createCloseAction() {
    const closeAction = new CloseModalWithReason(R.prop('reason', this.form.value));
    if (hasNoValue(super.confirmActions) || !hasCorrelationId(R.head(super.confirmActions))) {
      return closeAction;
    }
    const correlationId = getCorrelationId(R.head(super.confirmActions));
    return createActionWithCorrelationId(closeAction, correlationId);
  }
}
